Auth = require 'db/auth'
Label = require 'models/label'
Member = require 'models/member'
MemberAvatar = require 'views/member/member-avatar-react'
ModelCache = require 'db/model-cache'
ModelCacheListener = require 'views/internal/model-cache-listener'
React = require 'react'
Storage = require 'lib/storage'
TFM = require 'lib/markdown/tfm'
Util = require 'lib/util'
_ = require 'underscore'
localizeCount = require 'lib/localize-count'
t = require('views/internal/recup-with-helpers')('home_up_next')
trackUe = require 'debug/trackUe'
{ CanonicalCard } = require 'views/canonical-card/canonical-card-components'
{ CanonicalDetail } = require 'views/canonical-detail/canonical-detail-components'
{ BoardAndDetailContainer } = require '@atlassian/trello-canonical-components/canonical-card'
{ getOverflowItems, UP_NEXT_TYPE } = require 'views/home/overflow-menu'
ReactionHelper = require 'lib/reaction-helper'
EmojiReactionHelper = new ReactionHelper()

class UpNext extends React.Component
  displayName: 'UpNext'

  constructor: (props) ->
    super props

    { board, item, modelCache, card } = props

    @dueSoon = item.type == 'dueSoon'
    @action = item.type == 'action'
    @actionItem = item.data?.action
    @actionMemberCreator = if @actionItem && @actionItem.memberCreator then new Member(@actionItem?.memberCreator, modelCache: modelCache)

    @isEdited = @actionItem && @actionItem.data?.dateLastEdited
    @isComment = @actionItem?.type == 'commentCard'
    @isAddMemberToCard = @actionItem?.type == 'addMemberToCard'

    @canReply = (@isComment || @isAddMemberToCard) && @actionMemberCreator && board?.canComment(Auth.me())

    @state = {
      isReplying: false
      isWaitingForNetworkResponse: false
      replyMessage: if @canReply && !Auth.isMe(@actionMemberCreator) then "@#{@actionMemberCreator?.get('username')} " else ''
      cardChanged: 0 # Used to re-render when the backbone model changes.
      replyFailedStatusCode: null
    }

    @trackingPrepositionalObject = @getTrackingPrepositionalObject()
    @trackingIndirectObject = @getTrackingIndirectObject()

    @onReplyClick = @onReplyClick.bind(@, card.id, @actionItem?.id)
    @onSaveClick = @onSaveClick.bind(@, card.id, @actionItem?.id)
    @onCancelClick = @onCancelClick.bind(@, card.id, @actionItem?.id)
    @onChangeReplyMessage = @onChangeReplyMessage.bind(@)
    @trackOnClickCanonicalCard = @trackOnClickCanonicalCard.bind(@, card.id)
    @dismissCard = @dismissCard.bind(@)
    @onCompleteClick = @onCompleteClick.bind(@, card.id)
    @trackOverflowMenuOpens = @trackOverflowMenuOpens.bind(@)

  componentDidMount: ->
    @listenOnCardChange()

    commentDraftText = Storage.get @_commentDraftKey()
    if commentDraftText
      @setState replyMessage: commentDraftText

  componentDidUpdate: (prevProps) ->
    if prevProps.card != @props.card
      @props.clearModelListeners()
      @listenOnCardChange()

  listenOnCardChange: =>
    @props.modelListener @props.card, 'change', =>
      if @props.item.type == 'dueSoon' && !@props.card.getDueDate()
        @props.optimisticallyDismissCard(@props.upNextId, true, false)

      @setState (prevState) -> cardChanged: prevState.cardChanged + 1

  getTrackingPrepositionalObject: ->
    if @isComment
      return 'member is @-mentioned on'
    else if @dueSoon
      if !!@props.card.memberList?.models?.find((member) => member.owned())
        return "member is assigned to that's due soon/recently overdue"
      else
        return "no one is assigned to that's due soon/recently overdue"
    else if @isAddMemberToCard
      if Auth.isMe(@actionMemberCreator)
        return 'member added self to'
      else
        return 'member is added to'
    else
      return ''

  getTrackingIndirectObject: ->
    if @isComment
      return 'on card member is @-mentioned on'
    else if @dueSoon
      if !!@props.card.memberList?.models?.find((member) => member.owned())
        return "on card member is assigned to that's due soon/recently overdue"
      else
        return "on card no one is assigned to that's due soon/recently overdue"
    else if @isAddMemberToCard
      if Auth.isMe(@actionMemberCreator)
        return 'on card member added self to'
      else
        return 'on card member is added to'
    else
      return ''

  trackOverflowMenuOpens: (cardId) ->
    trackUe('home', 'opens', 'overflow menu', '', @trackingIndirectObject, 'by clicking overflow menu icon on up next card', { cardId: cardId })

  onReplyClick: (cardId, actionId, event) ->
    actionVerb = if !@state.isReplying then 'opens' else 'dismisses'
    trackUe('home', actionVerb, 'comment field', '', @trackingIndirectObject, 'by clicking reply on up next card', { cardId: cardId, actionId: actionId })
    @setState (prevState) -> isReplying: !prevState.isReplying

  onCancelClick: (cardId, actionId, event) ->
    trackUe('home', 'dismisses', 'comment field', '', @trackingIndirectObject, 'by clicking cancel on up next card', { cardId: cardId, actionId: actionId })
    @setState isReplying: false

  _commentDraftKey: -> "draft_#{@props.upNextId}_comment"

  onChangeReplyMessage: (e) ->
    Util.preventDefault(e)
    commentText = e.target.value
    @setState replyMessage: commentText
    if commentText
      Storage.set @_commentDraftKey(), commentText
    else
      Storage.unset @_commentDraftKey()
    return

  onSaveClick: (cardId, actionId, event) ->
    if @canReply
      { card, optimisticallyDismissCard, upNextId } = @props
      trackUe('home', 'adds', 'comment', '', @trackingIndirectObject, 'by clicking save on up next card', { cardId: cardId, actionId: actionId })
      @setState isWaitingForNetworkResponse: true
      card.addComment(@state.replyMessage)
        .then =>
          @setState isWaitingForNetworkResponse: false
          optimisticallyDismissCard(upNextId)
        .catch (error) =>
          @setState {
            replyFailedStatusCode: error.status || true
            isWaitingForNetworkResponse: false
          }

  dismissCard: ->
    { card, dismissUpNextCard, upNextId } = @props

    dismissUpNextCard(card?.get('id'), upNextId, @trackingPrepositionalObject)

  onCompleteClick: (cardId, event) ->
    { card, optimisticallyDismissCard, upNextId } = @props

    trackUe('home', 'completes', 'card', @trackingPrepositionalObject, '', 'by clicking complete button in up next feed', { cardId: cardId })
    card.update({ dueComplete: true })
    optimisticallyDismissCard(upNextId)

  trackOnClickCanonicalCard: (cardId, event) ->
    trackUe('home', 'opens', 'card', @trackingPrepositionalObject, '', 'by clicking card in up next feed', { cardId: cardId })

  render: t.renderable ->
    { board, card, item, list, modelCache, org, setFocusedCard, upNextId } = @props
    { isReplying, isWaitingForNetworkResponse, replyMessage, replyFailedStatusCode } = @state

    _tfmFormatOpts = {
      card
      board
      siteDomain
      textData: @actionItem?.data?.textData
    }

    t.tag BoardAndDetailContainer, =>
      t.div { onClick: @trackOnClickCanonicalCard }, =>
        t.tag CanonicalCard, {
          board
          boardClassName: 'canonical-stretch'
          canRemove: false
          card
          cardClassName: 'canonical-stretch'
          labels: card.getLabels()?.sort(Label.compare)
          list
          lightBackground: true
          members: card.memberList?.models
          numNotifications: 0
          organization: org
        }

      t.div =>
        t.tag CanonicalDetail, {
          @dueSoon
          @trackOverflowMenuOpens
          actionMemberCreator: @actionMemberCreator
          board
          canDismiss: true
          canReply: @canReply
          cardId: card.id
          collapseComment: @isComment
          commentText: if @isComment then TFM.comments.format(@actionItem?.display?.entities?.comment?.text, _tfmFormatOpts).output
          date: @actionItem?.date
          dueDate: card.get('badges')?.due
          isActionMemberCreatorDeleted: item.data?.action?.display?.entities?.memberCreator?.translationKey == 'action_deleted_account'
          isAddMemberToCard: @isAddMemberToCard
          isEdited: @isEdited
          isReplying
          isWaitingForNetworkResponse
          memberCreator: Auth.me()
          onCancelClick: @onCancelClick
          onChangeReplyMessage: @onChangeReplyMessage
          onCompleteClick: @onCompleteClick
          onDismissClick: @dismissCard
          onReplyClick: @onReplyClick
          onSaveClick: @onSaveClick
          overflowMenuItems: getOverflowItems(card, UP_NEXT_TYPE, modelCache, @trackingPrepositionalObject, @trackingIndirectObject)
          reactions: if @isComment then EmojiReactionHelper.groupReactions(@actionItem?.reactions?)
          replyFailedStatusCode
          replyMessage
          setFocusedCard: => setFocusedCard(card)
        }

module.exports = ModelCacheListener(UpNext)



// WEBPACK FOOTER //
// ./app/scripts/views/home/up-next.coffee